import tr from './tr';

export default {
  // en,
  tr
};
